import { ICellEditor, ICellEditorParams } from 'ag-grid-community';
import { forwardRef } from 'react';
import { ItemDataType } from 'rsuite/cjs/@types/common';
import { AsyncCellSelect } from '@aleph/shared-components';

interface IMinOSVersionCellEditor extends ICellEditorParams {
	deviceType: string;
}

export const MinOsVersionOptions = [
	{ value: '7', label: '7', os: 'ANDROID' },
	{ value: '8', label: '8', os: 'ANDROID' },
	{ value: '9', label: '9', os: 'ANDROID' },
	{ value: '10', label: '10', os: 'ANDROID' },
	{ value: '11', label: '11', os: 'ANDROID' },
	{ value: '12', label: '12', os: 'ANDROID' },
	{ value: '13', label: '13', os: 'ANDROID' },
	{ value: '14', label: '14', os: 'IOS' },
	{ value: '15', label: '15', os: 'IOS' },
	{ value: '16', label: '16', os: 'IOS' },
];

const MinOSVersionCellEditor = forwardRef<ICellEditor, IMinOSVersionCellEditor>((
	params,
	ref,
) => {
	// TODO: This is temporary. It will be changed after backend query is ready for fetching the OS versions.
	const loadOptions = async (): Promise<ItemDataType[]> => new Promise((resolve) => {
		const filteredData = MinOsVersionOptions.filter((item) => item.os === params.deviceType);
		resolve(filteredData);
	});

	return (
		<AsyncCellSelect
			ref={ref}
			{...params}
			loadOptions={loadOptions}
			isSearchable={false}
			isClearable={false}
			overrideGetValue={(value) => value?.value}
			selectedValue={params?.value}
		/>
	);
});

export default MinOSVersionCellEditor;
